<template>
    <v-card elevation="0">
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-container fluid class="user-list mt-3" v-if="languageData.labels && languageData">
      <v-row class="ma-0 mb-7">
        <div>
          <v-btn @click="addProjectEntry" color="primary" class="mr-2">
            <v-icon class="mr-2">mdi-plus</v-icon>
            {{ languageData.btnAddProjectEntryList }}
          </v-btn>
        </div>

        <div>
          <v-btn @click="addProjectBuildingDiary" color="primary">
            <v-icon class="mr-2">mdi-plus</v-icon>
            {{ languageData.btnAddProjectBuildingDiary }}
          </v-btn>
        </div>
      </v-row>
      <v-data-table
          :loading-text="languageData.labels.loadingPleaseWait"
          :loading="loadingProjectReportEntries"
          class="users-table"
          :headers="headersProjectReportEntries"
          :items="projectReportEntries"
          :options.sync="paginationProjectReportEntries"
          :footer-props="footerOptions"
          :page.sync="currentPage"
          :server-items-length="totalItems"
          :items-per-page-options="rowsPerPage"
          mobile-breakpoint="0"
      >
        <template v-slot:item.date="{ item }">
          {{ item.date }} <br>
          {{ item.termin }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="showEditProjectReportEntriesModal(item)"
                icon>
                <v-icon color="fontDefault">edit</v-icon>
              </v-btn>
            </template>
            <span>{{ languageData.labels.edit }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="showDeleteProjectReportEntriesModal(item)"
                  icon>
                <v-icon color="fontDefault">delete</v-icon>
              </v-btn>
            </template>
            <span>{{ languageData.labels.delete  }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <ModalInfo :headModal="languageData.projectReportEntriesDeleteModal.head"  @doOperation="removeProjectEntry" :vis-dis-agree-btn="true" @clicked="hideModalProjectReportEntry" :vis-agree-btn="true" :btnAgreeText="languageData.buttonsText.btnAgreeText" :show-modal="isShowModalDeleteDataProjectEntry" type-info="primary" :textModal="languageData.projectReportEntriesDeleteModal.textInfo + ' ' + modalDeleteDataProjectEntry.id + ' ?'" :btn-dis-agree-text="languageData.btnDisAgreeText"></ModalInfo>
    </v-container>
  </v-card>
</template>

<script type="text/javascript">
import eventBus from "../../../event-bus/eventBus";
import {mapActions, mapState} from "vuex";
import ModalInfo from "../../../components/ModalInfo/ModalInfo";

export default {
  name: "ProjectReportEntriesTable",
  data() {
    return {
      projectReportEntries: [],
      projectReportEntryToDeleteId: [],
      footerOptions: {
        'items-per-page-options': [20, 50, 100],
        'disablePagination': false
      },
      currentPage: 1,
      activePicker: null,
      date: null,
      menu: false,
      isShowModalDeleteDataProjectEntry: false,
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 7500,
        title: null,
        visible: false
      }
    }
  },
  components: {
    ModalInfo
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    }
  },
  methods: {
    ...mapActions("getProjectReportEntries", ["getProjectReportEntries"]),
    ...mapActions("getProjectReportEntriesHeaders", ["getProjectReportEntriesHeaders"]),
    ...mapActions("deleteProjectEntry", ["setModalDeleteDataProjectEntry", "removeProjectEntry"]),
    save(date) {
      this.$refs.menu.save(date)
    },
    addProjectEntry: function () {
      eventBus.$emit("showAddProjectEntryModal");
    },
    addProjectBuildingDiary: function () {
      // eventBus.$emit("showAddProjectEntryModal");
    },
    searchProjectReportEntries: function (valueSearch = {}, filters = false) {
      valueSearch.language = this.getCurrentLanguage;
      valueSearch.filters = filters;
      this.getProjectReportEntries({valueSearch});
      if (filters) {
        this.currentPage = 1;
      }
    },
    hideModalProjectReportEntry: function () {
      this.isShowModalDeleteDataProjectEntry = false;
    },
    showDeleteProjectReportEntriesModal: function (item) {
      this.isShowModalDeleteDataProjectEntry  = true;
      this.setModalDeleteDataProjectEntry(item);
    },
    showEditProjectReportEntriesModal: function (item) {
      eventBus.$emit("showEditProjectReportEntriesModal", item);
    },
    getSnackbarSuccess: function(title, message) {
      this.snackbar = {
        color: "success",
        icon: "check_circle",
        mode: "multi-line",
        position: "top",
        timeout: 7500,
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    }
  },
  computed: {
    ...mapState("getProjectReportEntriesHeaders", {
      headersProjectReportEntries: state => state.headersProjectReportEntries
    }),
    ...mapState("getProjectReportEntries", {
      loadingProjectReportEntries: state => state.loadingProjectReportEntries,
      paginationProjectReportEntries: state => state.pagination,
      totalItems: state => state.pagination.totalItems,
      rowsPerPage: state => state.pagination.rowsPerPage
    }),
    ...mapState("deleteProjectEntry", {
      modalDeleteDataProjectEntry: state => state.modalDeleteDataProjectEntry
    }),
    paginationProjectReportEntries: {
      set: function (value) {
        this.searchProjectReportEntries(value);
      },
      get: function () {
        return this.$store.state.getProjectReportEntries.pagination;
      }
    }
  },
  mounted() {
    this.getProjectReportEntriesHeaders({language: this.getCurrentLanguage});
    eventBus.$on("getProjectReportEntriesSuccess", (dataReceive) => {
      this.projectReportEntries = dataReceive;
    });
    eventBus.$on(["deleteProjectReportEntrySuccess", "saveOrUpdateProjectEntrySuccess"], (dataReceive) => {
      this.searchProjectReportEntries();
      this.getSnackbarSuccess(dataReceive.text, dataReceive.message);
    });
     eventBus.$on("saveProjectReportEntrySuccess", () => {
      this.searchProjectReportEntries();
    });
    eventBus.$on("updateProjectTaskSuccess", () => {
      this.searchProjectReportEntries();
    });
    eventBus.$on("saveMeasurementSuccess", () => {
      this.searchProjectReportEntries();
    });
     eventBus.$on("saveVobDocumentSuccess", () => {
      this.searchProjectReportEntries();
    });
    eventBus.$on("sendVobDocumentSuccess", () => {
      this.searchProjectReportEntries();
    });
  },
  beforeDestroy() {
    eventBus.$off('saveOrUpdateProjectEntrySuccess');
    eventBus.$off('saveProjectReportEntrySuccess');
    eventBus.$off('updateProjectTaskSuccess');
    eventBus.$off('saveMeasurementSuccess');
  }
}
</script>